
import { useState } from "react";
import  "./MouthfeelIntensity.css";


const FermentProfile = ({data,handleChange, count})=>{
  const [val, setVal] = useState(data.fermentprofile===0?0:data.fermentprofile);

  function onChangeValue(event) {
    setVal(event.target.value);
    console.log(event.target.value+2);
    handleChange(event);
  }
    return (
  <div class="MouthfeelIntensityradiocard" name="fermentprofile"  onChange={onChangeValue}>
    <div class="MouthfeelIntensityrating-container">
      
      <div class="MouthfeelIntensityrating">
        <form class="MouthfeelIntensityrating-form-1" >

        <label for={`FP1F-${count}`}>
        <input type="radio"  name="fermentprofile" class="fermentprofile1" id={`FP1F-${count}`}  value="1"  checked={'' + val === "1"} />
        <div className="circle">1</div>
        </label>
  
          <label for={`FP2F-${count}`}>
        <input type="radio" name="fermentprofile" class="fermentprofile2" id={`FP2F-${count}`} value="2" checked={'' + val === "2"} />
       <div className="circle">2</div>
        </label>
  
          <label for={`FP3F-${count}`}>
      <input type="radio" name="fermentprofile" class="fermentprofile3" id={`FP3F-${count}`} value="3" checked={'' + val === "3"} />
       <div className="circle">3</div>

        </label>
  
          <label for={`FP4F-${count}`}>
        <input type="radio" name="fermentprofile" class="fermentprofile4" id={`FP4F-${count}`} value="4" checked={'' + val === "4"} />
        <div className="circle">4</div>
       
        </label>
  
          <label for={`FP5F-${count}`}>
        <input type="radio" name="fermentprofile" class="fermentprofile5" id={`FP5F-${count}`} value="5" checked={'' + val === "5"} />
        <div className="circle">5</div>
                </label>
        </form>
      </div>
    </div>
  </div>
  

    );
}

export default FermentProfile;